import type { DateRange, PredefinedDateRange } from '@fv/models'
import { dates } from '@fv/models/core'

export type ParsedDateRange = {
  name: PredefinedDateRange | 'custom'
  isCustom: boolean
  start?: Date
  end?: Date
}

export const parseDateRange = (
  value: string | null | undefined,
  defaultRange: PredefinedDateRange = 'last-7-days',
): ParsedDateRange => {
  if (!value) {
    return {
      name: defaultRange,
      isCustom: false,
      start: undefined,
      end: undefined,
    }
  }

  const range = dates.parseDateRange(value as DateRange)

  return {
    ...range,
    start: range.start?.toDate(),
    end: range.end?.toDate(),
    isCustom: range.name === 'custom',
  }
}
